import React from 'react';
import './ServerIcon.css';

/**
 * Icône d'un serveur Discord ; sans icône, initiale sur une couleur stable dérivée de l'ID.
 */
const ServerIcon = ({ guild, size = 56, className = '' }) => {
    const style = { width: size, height: size, fontSize: Math.round(size * 0.4) };

    if (guild?.icon) {
        return (
            <img
                className={`server-icon ${className}`}
                style={style}
                src={`https://cdn.discordapp.com/icons/${guild.id}/${guild.icon}.png`}
                alt=""
            />
        );
    }

    const purple = Number(String(guild?.id || '0').slice(-1)) % 2 === 1;
    return (
        <div className={`server-icon server-icon--letter${purple ? ' server-icon--purple' : ''} ${className}`} style={style} aria-hidden="true">
            {(guild?.name || '?').charAt(0).toUpperCase()}
        </div>
    );
};

export default ServerIcon;
